import { createContext, PropsWithChildren, useContext } from "react";

export interface StickyCtaContextValue {
    isSticky?: boolean;
}

const StickyCtaContext = createContext<StickyCtaContextValue | undefined>(
    undefined
);

export const useStickyCtaContext = () => {
    const context = useContext(StickyCtaContext);
    if (!context) {
        return {
            isSticky: false
        };
    }
    return context;
};

export interface StickyCTAContextProviderProps extends PropsWithChildren {
    isSticky?: boolean;
}

export const StickyCTAContextProvider = (
    props: StickyCTAContextProviderProps
) => {
    return (
        <StickyCtaContext.Provider value={props}>
            {props.children}
        </StickyCtaContext.Provider>
    );
};
